'use client';
import { useInView } from '@bedrock/analytics/hooks';
import { analytics } from 'ui/analytics';

export function HeroAnalytics({ text }: Readonly<{ text: string }>) {
  const ref = useInView<HTMLDivElement>(() => {
    analytics.viewPromotion({
      promotionId: 'P_12345',
      promotionName: text || 'Promo Dummy Heading',
      creativeName: `${text} Hero`,
      creativeSlot: 'Hero',
    });
  });

  return <div ref={ref} />;
}
